
import { AppState } from "@/store/types";
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  watch,
  ref,
} from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Card from "primevue/card";
import Button from "primevue/button";
import { RATING_MAX } from "@/static/data.config";
import Rating from "primevue/rating";
import Calendar from "primevue/calendar";
import { timestampsToDates } from "@/services/utils.service";

export default defineComponent({
  components: {
    Card,
    Button,
    Rating,
    Calendar,
  },
  setup() {
    const store = useStore<AppState>();

    const route = useRoute();
    const recipeId = route.params.id;

    const recipe = computed(() => store.state.activeRecipe);
    const user = computed(() => store.state.user);
    const maxDateValue = ref<Date>(new Date());

    const selectedDates = computed(() =>
      timestampsToDates(recipe.value?.dates || [])
    );

    onMounted(() => {
      store.dispatch("fetchRecipeById", recipeId);
    });

    watch(user, () => {
      if (user.value) store.dispatch("fetchRecipeById", recipeId);
    });

    onUnmounted(() => {
      store.dispatch("resetActiveRecipe");
    });

    return {
      recipeId,
      recipe,
      RATING_MAX,
      selectedDates,
      maxDateValue,
    };
  },
});
